// One tap fills in what the Observer should help with. Plain text: people edit it freely.
export const SITUATIONS = [
  ["Decision", "Help us reach a clear decision: lay out the options, what we are weighing them on, who isn't on board, and what is still open."],
  ["Disagreement", "Help us through a disagreement: notice where people talk past each other, name what each side actually needs, and suggest a way forward without taking sides."],
  ["Review", "Check what is said against our numbers and goals: flag slippage, risks and anything glossed over."],
  ["Discussion", "Widen the discussion: bring in angles nobody has raised, connect ideas from different people, and question assumptions."],
  ["Negotiation", "Track what each side really wants, what has been offered or conceded, and what is still unanswered."],
];

// A chip replaces the text if it is empty or another chip's text; otherwise it is added on a new line.
export function applySituation(current, text) {
  const cur = (current || "").trim();
  if (!cur || SITUATIONS.some(([, t]) => t === cur)) return text;
  return cur.includes(text) ? cur : `${cur}\n${text}`;
}
